// Nem todo contato tem telefone.
//
// O campo `number` guarda o que permite responder, e isso muda com o canal:
// no WhatsApp é o telefone, no Messenger e no Direct é o PSID/IGSID (um id de
// 16 a 17 dígitos, por escopo do app), no Telegram é o id do chat e no widget
// de site é a sessão do visitante.
//
// Tratar todos como telefone dava dois defeitos visíveis: uma bandeira de país
// inventada a partir dos primeiros dígitos de um id, e um link "tel:" que
// abria o discador com um número que não existe.

// Sessão do widget de site. O prefixo é gravado pelo backend
// (WebchatHelpers.PREFIXO_CONTATO) justamente para ser reconhecível.
const PREFIXO_WEBCHAT = "web_";

// Telefone com DDI cabe em 15 dígitos (padrão E.164). Um PSID do Messenger
// tem 16 ou 17 — é o que separa os dois sem precisar saber o canal.
const MAX_DIGITOS_TELEFONE = 15;

// Canais cujo identificador é telefone de verdade. O WhatsApp por sessão e o
// oficial são os dois — no oficial o webhook entrega o número mesmo.
const CANAIS_COM_TELEFONE = ["whatsapp", "whatsapp_official"];

// `canal` vem da conexão do atendimento, quando a tela a tem. É o único sinal
// confiável: o id de um chat do Telegram tem 9 dígitos e passa por telefone em
// qualquer heurística — o de teste virava "+98 7654321", um número do Irã.
// Sem o canal, sobra a forma do texto, que ainda resolve webchat e PSID.
export const ehTelefone = (numero, ehGrupo = false, canal) => {
  const texto = String(numero || "").trim();

  if (!texto) return false;

  // Grupo do WhatsApp tem identificador próprio, e a tela já o trata à parte.
  if (ehGrupo) return true;

  if (canal) return CANAIS_COM_TELEFONE.includes(canal);

  if (texto.startsWith(PREFIXO_WEBCHAT)) return false;

  const digitos = texto.replace(/[^0-9]/g, "");

  // Sobrou letra ou símbolo no meio: não é telefone (o "@usuario" de um bot
  // do Telegram, por exemplo).
  if (digitos.length !== texto.replace(/^\+/, "").length) return false;

  return digitos.length > 0 && digitos.length <= MAX_DIGITOS_TELEFONE;
};

// Como mostrar um identificador que não é telefone. Encurta o que é longo
// demais para caber numa linha — o valor inteiro fica no `title`, para quem
// precisar copiar.
export const rotuloDoIdentificador = (numero, canal) => {
  const texto = String(numero || "").trim();

  // No Telegram o identificador é o id do chat — um número que não é
  // telefone. Dizer de onde ele é evita a pergunta "que número é esse?".
  if (canal === "telegram") return `Telegram ${texto}`;

  if (texto.startsWith(PREFIXO_WEBCHAT)) {
    return `Visitante ${texto.slice(PREFIXO_WEBCHAT.length, PREFIXO_WEBCHAT.length + 8)}`;
  }

  return texto.length > 20 ? `${texto.slice(0, 20)}…` : texto;
};

export default ehTelefone;
